'use strict';

exports.__esModule = true;

var _redux = require('redux');

var _reactRouterRedux = require('react-router-redux');

var _reduxConnect = require('redux-connect');

var _survey = require('./survey');

var _survey2 = _interopRequireDefault(_survey);

var _client = require('./client');

var _client2 = _interopRequireDefault(_client);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import filterDate from './filter/date';

var appReducer = (0, _redux.combineReducers)({
  routing: _reactRouterRedux.routeReducer,
  reduxAsyncConnect: _reduxConnect.reducer,
  survey: _survey2.default,
  client: _client2.default
  // filterDate,
});

var catchError = function catchError(state, action) {
  var errorsToCatch = ['survey'];
  var handleError = function handleError(actionType) {
    window.actionTypeErrorName = actionType;
    window.location.href = '/#/error';
    // window.location.reload();
  };
  errorsToCatch.forEach(function (error) {
    if (action.type.includes(error)) {
      handleError(error);
    }
  });
};

var rootReducer = function rootReducer(state, action) {
  var newstate = state;
  if (action.type.includes('FAIL')) {
    catchError(state, action);
  }
  return appReducer(newstate, action);
};

exports.default = rootReducer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/reducer.js
// module id = 1421
// module chunks = 0